var React = require('react');

function VertArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_213","data-name":"Group 213","transform":"translate(-678.822 -591.167)"},[React.createElement("line",{"id":"Line_11","data-name":"Line 11","y2":"100","transform":"translate(683.5 591.167)","fill":"none","stroke":"#f7f6f2","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_539","data-name":"Path 539","d":"M-17370.824,687.284l4.285,4.285,4.285-4.285","transform":"translate(18050)","fill":"none","stroke":"#f7f6f2","strokeWidth":"1","key":1})]));
}

VertArrowInline.defaultProps = {"width":"9.277","height":"101.109","viewBox":"0 0 9.277 101.109"};

module.exports = VertArrowInline;

VertArrowInline.default = VertArrowInline;
